<template>
    <div class="nybj1">
        <div class="nybj2">
            <div class="nybox" style="border: 1px solid #03A643;">
                <div class="ny_left">
                    <div class="left_dh">
                        <div class="ldh_title">
                            <h2>
                                医生介绍<span></span></h2>
                        </div>
                        <div class="ldh_nr">
                            <ul>

                                <li class="">
                                    <router-link :to="'/doctor-list/'" title="医大专家">医大专家</router-link>
                                </li>

                                <li class="hover_b">
                                    <router-link :to="'/doctor-list/'" title="名医风采">名医风采</router-link>
                                </li>

                                <li class="">
                                    <router-link :to="'/news-list/85'" title="医疗纵横">医疗纵横</router-link>
                                </li>

                                <li class="">
                                    <router-link :to="'/news-list/86'" title="护理天地">护理天地</router-link>
                                </li>

                                <li class="">
                                    <router-link :to="'/news-list/87'" title="特色技术">特色技术</router-link>
                                </li>

                                <li class="">
                                    <router-link :to="'/news-list/88'" title="健康大讲堂">健康大讲堂</router-link>
                                </li>

                                <li class="">
                                    <router-link :to="'/person/'" title="人体就医导航">人体就医导航</router-link>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="ny_right">
                    <div class="dqwz">
                        <p>
                            当前位置：<a href="index.aspx">首页</a>&nbsp;&gt;&nbsp;医生介绍
                        </p>
                    </div>
                    <div data-role="page" id="clientAlipay" class="right-intr1">
                        <div>
                            <div class="expertList">
                                <div class="expertInfo">
                                    <div class="expertPic" style="background:URL(images/000.png) no-repeat;  width:183px; height:210px; margin-top:20px">
                                        <img :src="info.logo" style="width:170px; height:195px; margin-left:6px;">
                                    </div>
                                    <div class="expertText">


                                        <h3 style="color: #333; margin: 0; padding: 0;margin-top:-5px">
                                            {{info.name}}
                                        </h3>
                                        <h4 class="beginTime" style="color:#f191c2;font-weight:normal; line-height:22px; margin-top:-10px;">
                                            <strong>职务：</strong> {{info.zw}}  </h4>
                                        <h4 class="beginTime" style="color:#f191c2;font-weight:normal; line-height:22px;">
                                            <strong>职称：</strong> {{info.job}}</h4>
                                        <h4 class="beginTime" style="color:#f191c2;font-weight:normal; line-height:22px;">
                                            <strong>科系：</strong> <a href="ksShow.aspx?id=68">{{info.kname}}</a>
                                        </h4>
                                        <h4 class="beginTime" style="color:#f191c2;font-weight:normal; line-height:22px;display:none">
                                            <strong>诊室：</strong> {{info.item4}}
                                        </h4>
                                        <h5 class="place" style="font-weight:normal; line-height:22px;">
                                            <strong>开诊时间：</strong>{{info.item3}} </h5>
                                        <h5 class="place" style="font-weight:normal; line-height:22px;">
                                            <strong>出诊地点：</strong> {{info.item5}}</h5>


                                        <p style="height:15px;"></p>
                                        <div style=" margin-left:-175px;display:none"><img src="images/xin.png" style="width:170px; "> </div>
                                        <div style="background:#59CC8B; width:100%;height:1px; margin-left:-175px;"></div>
                                        <p style="height:15px;"></p>
                                        <h5 class="place" style="color:#7f5426;font-weight:normal;margin-left:-200px;"><div>
                                            <p class="p"
                                               style="margin-top:3.7500pt;margin-right:0.0000pt;margin-bottom:3.7500pt;margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;line-height:16.5000pt; color:#4d4d4d; font-size:17px;"
                                               v-html="info.contents">

                                            </p>
                                        </div></h5>
                                        <p style="height:15px;"></p>
                                        <img src="../../assets/images/shanchang.png" style="width:100%;margin-left:-185px;">
                                        <p style="height:15px;"></p>
                                        <h5 class="place" style="color:#7f5426;font-weight:normal;margin-left:-200px;"><div>
                                            <p class="p" style="margin-top:3.7500pt;margin-right:0.0000pt;margin-bottom:3.7500pt;margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;line-height:15.5000pt; color:#4d4d4d; font-size:17px;"> {{info.item2}} </p>
                                        </div>

                                            <div class="list-item">
                                                <div class="list-tit">
                                                    <h2>
                                                        <span style="color: #03A643;">预约时间</span></h2>
                                                </div>
                                                <div class="list-content doctor-clinic">
                                                    <h2>备注：预约时间为未来三天后的七天</h2>
                                                    <table border="1">
                                                        <tbody>
                                                        <tr>
                                                            <th>
                                                            </th>

                                                            <th v-for="(item,i) in info.schedule" :key="i">
                                                               {{item.week}}
                                                            </th>

                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                上午
                                                            </td>

                                                            <td v-for="(item,i) in info.schedule" :key="i">
                                                                <a v-if="item.is_morning_appoint==1" @click="appoint(item,'morning')" href='javascript:void(0);' class="appoint">预约</a>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                下午
                                                            </td>

                                                            <td v-for="(item,i) in info.schedule" :key="i">
                                                                <a v-if="item.is_afternoon_appoint==1" href='javascript:void(0);' class="appoint">预约</a>
                                                            </td>

                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        <p style="height:15px;"></p></h5>
                                    </div>
                                </div>
                                <div class="clearFloat">
                                </div>
                            </div>

                        </div>
                        <div style="height: 20px;">
                        </div>
                        <div class="clearFloat">
                        </div>

                    </div>
                </div>
                <div class="dbgd">
                    <img src="../../assets/images/c_04.png" />
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>
    .appoint{
        background: #54A0EA;
        font-size: 15px;
        color: #fff;
        width: 100%;
        height: 95%;
        vertical-align: middle;
    }
</style>
<script>
    export default {
        name: 'DoctorInfo',
        data(){
            return{
                info:[]
            }
        },
        props:['doctor_id'],
        watch:{
            doctor_id:function(e){
                this.getDoctorInfo(e);
            }
        },
        methods:{
            getDoctorInfo:function(doctor_id){
                let that = this;
                that.$http.get(this.$api.getDoctorInfo.url,{doctor_id:doctor_id}).then(result => {
                    that.info = result.data;
                });
            },
            appoint:function(e,type){
                console.log(e);
                console.log(type);
                let that = this;
                let res = sessionStorage.getItem('userinfo');

                if(!res){
                    alert('请登录');
                    that.$router.push({name: 'Login'});
                }else{
                    that.$router.push({name: 'Appoint',params:{doctor:that.info,schedule:e,type:type}});
                }
            }
        },

        computed: {

        },
        mounted(){

            //this.getDoctorInfo(107);
        }
    }
</script>